module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.nextLvlRequirementsOpen) ? _c('div', {
    staticClass: "nlr__bg",
    on: {
      "click": _vm.closeNextLvlRequirements
    }
  }, [_c('div', {
    staticClass: "nlr__popup",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "nlr__popup__top free"
  }, [_c('div', {
    staticClass: "nlr__digit free"
  }, [_c('span', [_vm._v(_vm._s(_vm.nextFriendsLevel.num))])]), _vm._v(" "), _c('div', {
    staticClass: "nlr__text"
  }, [_c('div', {
    staticClass: "nlr__text__heading"
  }, [_vm._v(_vm._s(_vm.nextFriendsLevel.title))]), _vm._v(" "), _c('div', {
    staticClass: "nlr__text__subheading"
  }, [_vm._v(_vm._s(_vm.$t("pop_ups.next_lvl_requirements.achieve_start")) + " " + _vm._s(_vm.nextFriendsLevel.num) + _vm._s(_vm.$t("pop_ups.next_lvl_requirements.achieve_end")))]), _vm._v(" "), _c('ul', {
    staticClass: "nlr__text__checkpoint__list"
  }, _vm._l((_vm.nextFriendsLevel.requirements), function(req, index) {
    return _c('li', {
      key: index,
      staticClass: "nlr__text__checkpoint"
    }, [_c('span', {
      staticClass: "nlr__text__checkpoint_text"
    }, [_vm._v(_vm._s(req))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "nlr__progress"
  }, [_c('div', {
    staticClass: "nlr__progress__top"
  }, [_c('p', {
    staticClass: "nlr__progress__currentlvl"
  }, [_vm._v(_vm._s(_vm.currentLevel.name))]), _vm._v(" "), _c('p', {
    staticClass: "nlr__progress__points"
  }, [_c('span', [_vm._v(_vm._s(_vm.levelPointsEarned))]), _vm._v(" / " + _vm._s(_vm.levelPointsCap) + " " + _vm._s(_vm.$t("pop_ups.next_lvl_requirements.points")))])]), _vm._v(" "), _c('div', {
    staticClass: "nlr__progress__bar"
  }, [_c('div', {
    staticClass: "nlr__progress__bar__inner free",
    style: ({
      'width': _vm.progressPerc + '%'
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "nlr__popup__bottom"
  }, [_c('p', {
    staticClass: "nlr__link__container"
  }, [_c('span', {
    staticClass: "nlr__link",
    on: {
      "click": _vm.onLinkClicked
    }
  }, [_vm._v(_vm._s(_vm.$t("pop_ups.next_lvl_requirements.program_dets")))])]), _vm._v(" "), _c('div', {
    staticClass: "nlr__close free",
    on: {
      "click": _vm.closeNextLvlRequirements
    }
  }, [_vm._v(_vm._s(_vm.$t("pop_ups.next_lvl_requirements.close")))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84274068","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/next-lvl-reqirements.vue
// module id = 304
// module chunks = 1